export const TXTCLI_User_ID_XN0X_is_not_availlable_ELL = {
  "id": "TXTCLI_User_ID_XN0X_is_not_availlable_ELL",
  "defaultMessage": "Username ''{0}'' is not available. Please choose one of these suggestions or try another username."
} as const;

export const TXTWCL_Unable_to_validate_usernameX = {
  "id": "TXTWCL_Unable_to_validate_usernameX",
  "defaultMessage": "Unable to validate username."
} as const;

export const TXTWCL_Your_UserID_must_not_contain_s_ELL = {
  "id": "TXTWCL_Your_UserID_must_not_contain_s_ELL",
  "defaultMessage": "Your username must not contain special characters or spaces "
} as const;